import { createSlice } from '@reduxjs/toolkit';
import { reportError } from "../functions/sentry";

const initialState = {
  isInitialized: false,
  id: null,
  isSaved: false,
  isIelts: false,
  lessonData: {
    learnerHasAccessToLesson: true,
    iconUrl: 'https://files.flowspeak.io/files/default-avatar.png',
    title: 'Loading ...',
    initialDisplayMessage: 'Loading ...',
    description: 'Loading ...',
    everyMessageAddonResponderText: '',
    learnerSpeakingTurns: 6,
    relatedLessons: []
  },
  messages: [],
  responses: [],
  exerciseId: null
}

export const name = 'aiTalk';

const aiTalkSlice = createSlice({
  name,
  initialState,
  // The `reducers` field allows us define reducers and generate associated actions
  reducers: {
    setAiTalk: (state, action) => {
      state.isInitialized = true;
      state.id = action.payload.id;
      state.isSaved = action.payload.isSaved;
      state.isIelts = action.payload.isIelts;
      state.lessonData = action.payload.lessonData;
      state.messages = action.payload.messages;
    },

    addMessage: (state, action) => {
      state.messages = [...state.messages, action.payload];
    },

    addResponse: (state, action) => {
      // Try to prevent an error that I haven't been able to track down
      if( action?.payload?.success ) {
        try {
          state.responses = [...state.responses, action.payload];
        } catch {
          reportError(action);
        }
      }
    },

    setAiTalkIsSaved: (state, action) => {
      state.isSaved = action.payload;
    },

    setExerciseId: (state, action) => {
      state.exerciseId = action.payload
    },

    resetAiTalk: (state, action) => {
      state.id = initialState.id;
      state.lessonData = initialState.lessonData;
      state.isSaved = initialState.isSaved;
      state.isInitialized = initialState.isInitialized;
      state.messages = initialState.messages;
      state.responses = initialState.responses;
    },

  },
});

export const { actions, reducer } = aiTalkSlice;
export default aiTalkSlice;